module.exports = "/_next/static/media/onboard-1-grid.3c2189e2.webm";